<template>
  <ContentList :list="dimensionsBullets">
    <template #default="{ item }">
      <span v-html="item" />
    </template>
  </ContentList>
</template>

<script setup>
import ContentList from '@components/common/ContentList';
import { useProductDetails } from '../composables';

const { dimensionsBullets } = useProductDetails();
</script>
